import React from "react";
import {Link, useTranslation} from "gatsby-plugin-react-i18next";
import {ArrowRight, Database, FileText, Lock} from "@phosphor-icons/react";
import SectionHeading from "./section-heading";
import gdprBadge from "../../images/gdpr.webp";
import aiActIcon from "../../images/icons/ai-act.svg";

const Security = () => {
    const {t} = useTranslation();

    const points = [
        {icon: Database, title: t("Your data stays yours"), text: t("What you upload trains only your agent. It is never used to train models for anyone else, and you can delete a source or the whole bot at any time.")},
        {icon: Lock, title: t("Encrypted end to end"), text: t("Data is encrypted at rest and in transit. Access to the panel is per user and per bot, with roles for your team.")},
        {icon: FileText, title: t("Paperwork ready"), text: t("A data processing agreement is ready to sign, the sub-processor list is public and the AI Act transparency notice is built into the widget.")},
    ];

    return (
        <section className="w-full max-w-screen-2xl mx-auto px-5 flex flex-col gap-10">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
                <SectionHeading
                    eyebrow={t("Data and compliance")}
                    title={t("Built for GDPR.|Nothing hidden.")}
                    lead={t("Customers in the EU, data processing agreements with hotels and shops, audits by agencies. We built the paperwork in.")}
                />
                <div className="flex items-center gap-8 shrink-0">
                    <Link to="/blog/gdpr/" className="shrink-0">
                        <img src={gdprBadge} alt="GDPR compliant" className="w-44" width="176" height="44" loading="lazy"/>
                    </Link>
                    <Link to="/blog/ai-act-transparency/" className="shrink-0">
                        <img src={aiActIcon} alt="EU AI Act transparency" className="w-44" width="176" height="59" loading="lazy"/>
                    </Link>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--cl-rule)] border border-[var(--cl-rule)]">
                {points.map(({icon: Icon, title, text}) => (
                    <div key={title} className="bg-[var(--cl-surface)] p-8 sm:p-10 flex flex-col gap-4 min-h-[260px]">
                        <Icon size={26} className="text-[var(--cl-ink)]"/>
                        <h3 className="text-xl font-bold text-[var(--cl-ink)]">{title}</h3>
                        <p className="text-base leading-relaxed text-[var(--cl-ink-2)]">{text}</p>
                    </div>
                ))}
            </div>
            <div className="flex flex-wrap gap-8 text-[15px] font-semibold text-[var(--cl-ink)]">
                <Link to="/privacy/" className="inline-flex items-center gap-1.5 underline-offset-4 hover:underline">{t("Privacy Policy")} <ArrowRight size={14} weight="bold"/></Link>
                <Link to="/dpa/" className="inline-flex items-center gap-1.5 underline-offset-4 hover:underline">{t("Data Processing Agreement")} <ArrowRight size={14} weight="bold"/></Link>
                <Link to="/subprocessors/" className="inline-flex items-center gap-1.5 underline-offset-4 hover:underline">{t("Sub-processors")} <ArrowRight size={14} weight="bold"/></Link>
            </div>
        </section>
    );
};

export default Security;
